import { z } from 'zod';

/** Кусок ответа LLM в потоке `chunk`. */
export interface ChunkContentModel {
  readonly text: string;
}

/** Переименований нет — ключ `text` одинаков в сети и в модели. */
export const chunkContentModelSchema = z.object({
  text: z.string(),
});

export function chunkContentModelFromJson(json: unknown): ChunkContentModel {
  return chunkContentModelSchema.parse(json);
}

export function chunkContentModelToJson(
  model: ChunkContentModel,
): Record<string, unknown> {
  return {
    text: model.text,
  };
}
